import _ from 'lodash';
import { app } from '@/vendors/firebase/firebase';
import supplierTransformer from './supplierTransformer';
import OrderConstraint from '../../../entities/OrderConstraint';

export default {
  async getSuppliersByShopId(shopId) {
    const res = [];
    const snapshot = await app.firestore()
      .collection('suppliers')
      .where('shopIds', 'array-contains', shopId)
      .get();
    snapshot.forEach((doc) => {
      res.push(supplierTransformer.transformOne(doc.data()));
    });
    return supplierTransformer.transformList(res);
  },

  isConstraintsRespected(supplier, constraints, totalPrice) {
    const arrayOfNotRespectedConstraints = [];

    if (constraints.franco) {
      const francoRespected = this.isFrancoRespected(constraints.franco, supplier, totalPrice);
      if (!(_.isEmpty(francoRespected))) {
        arrayOfNotRespectedConstraints.push(francoRespected);
      }
    }
    return arrayOfNotRespectedConstraints;
  },

  isFrancoRespected(franco, order, totalPrice) {
    if (totalPrice < franco) {
      const missingPrice = franco - totalPrice;
      return new OrderConstraint({
        msg: `Le prix est inférieur au prix de franco, il manque ${missingPrice} euros. Veuillez ajouter des produits à votre commande`,
        supplier: order.key,
      });
    }
    return {};
  },

  totalPriceBySupplier(order) {
    let priceHt = 0;
    order.forEach(
      (product) => {
        const priceProduct = product.price * product.quantity * product.conditionning;
        priceHt += priceProduct;
      },
    );
    return priceHt;
  },
};
